import './MainMenu.css'
import Button from './MainMenuButton.jsx'
import PropTypes from 'prop-types';

MainMenu.propTypes = {
  activeScreen: PropTypes.string,
  onChange: PropTypes.func
};

const BUTTONS = [
  {icon: "book", caption: "Learning Feed"},
  {icon: "time", caption: "Challenges"},
  {icon: "plane", caption: "Virtual Flyout"},
  {icon: "calendar", caption: "Calendar"},
  {icon: "notifications", caption: "Notifications"},
  {icon: "graph", caption: "Statistics"}
]

export default function MainMenu( {activeScreen, onChange} ) {
  return (
    <div className="main-menu collapsed">
      <menu className="main-menu-container">
        {BUTTONS.map( (button, index) => (
          <Button key={index} icon={button.icon} caption={button.caption}
                  onClick={() => onChange(button.caption)}
                  active={button.caption === activeScreen}/>
        ))}
      </menu>
      <Button id="main-menu-collapse-button" icon="chevron_left"
              onClick={() => document.querySelector(".main-menu").classList.add("collapsed")}/>
      <Button id="main-menu-expand-button" icon="chevron_right"
              onClick={() => document.querySelector(".main-menu").classList.remove("collapsed")}/>
    </div>
  )
}